import React from "react";

export default function Title({ title }) {
  return (
    <div className="title-content">
      <h3>{title}</h3>
      <div></div>
    </div>
  );
}
